import { ImageConfig } from "konva/lib/shapes/Image";
import { useEffect } from "react";
import { Image as KonvaImage, KonvaNodeEvents } from "react-konva";
import useImage from "use-image";
import { Html } from "react-konva-utils";
import { Flex, Portal, Spinner, Text } from "@radix-ui/themes";

export function CanvasImage({
  src = "",
  onError,
  ...props
}: Omit<ImageConfig, "image"> &
  KonvaNodeEvents & {
    src: string | undefined;
    onError?: (error: Error) => void;
  }) {
  const [image, status] = useImage(src);

  useEffect(() => {
    if (status === "failed") {
      onError?.(new Error("Failed to load image"));
    }
  }, [status]);

  if (status === "loading")
    return (
      <Html>
        <Portal container={document.getElementById("canvas")}>
          <Flex className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 items-center justify-center">
            <Flex gap="2" align="center">
              <Spinner className="text-white"></Spinner>
              <Text size="2" className="text-[var(--gray-7)]">
                Loading image...
              </Text>
            </Flex>
          </Flex>
        </Portal>
      </Html>
    );

  if (!(src && image)) return null;

  return (
    <KonvaImage
      width={1920 / 2}
      height={1080 / 2}
      fit="contain"
      {...props}
      image={image}
    />
  );
}
